export type ComparedTally = {
  productName: string;
  cannedTallyName: string | null;
  cannedTallyCount: number | null;
};

type TallyRequest = {
  tallyPlatformProduct?: { name: string } | null;
  cannedTally?: { name: string } | null;
  cannedTallyCount?: number | null;
};

export function comparedTallyOf(
  requestForQuote: TallyRequest
): ComparedTally | null {
  const tallyPlatformProduct = requestForQuote.tallyPlatformProduct;
  if (!tallyPlatformProduct) return null;
  const cannedTally = requestForQuote.cannedTally ?? null;
  return {
    productName: tallyPlatformProduct.name,
    cannedTallyName: cannedTally === null ? null : cannedTally.name,
    cannedTallyCount: requestForQuote.cannedTallyCount ?? null,
  };
}
